import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import checkoutReducer from './checkoutPage/data/reducer';
import checkoutSaga from './checkoutPage/data/sagas';
import digiQuoteReducer from './digiQuotePage/data/reducer';
import digiQuoteSaga from './digiQuotePage/data/sagas';
import routes from './routes';

const reducer = combineReducers({
  digiQuotePage: digiQuoteReducer,
  checkoutPage: checkoutReducer,
});

const saga = function* () {
  yield all([digiQuoteSaga(), checkoutSaga()]);
};

export { reducer, saga, routes };
